
@if(linkedContent.length === 0) {
    {{ content }}
} 
@else {
    @for (part of linkedContent; track part.id; let idx = $index) {
        @if(part.type === 'text') {
            {{ part.original }}
        } 
        @else if(part.type === 'link') {
            <span [innerHTML]="part.transformed"></span>
        }
    }
}